import { render, staticRenderFns } from "./OrganisationTab.vue?vue&type=template&id=342e0fce&"
import script from "./OrganisationTab.vue?vue&type=script&lang=js&"
export * from "./OrganisationTab.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
